import { createAction } from 'redux-actions';

export const clearCustomList = createAction('CLEAR_CUSTOM_LIST');

export const customListOnChangePage = createAction(
  'CUSTOM_LIST_ON_CHANGE_PAGE'
);

export const customListOnChangeOrder = createAction(
  'CUSTOM_LIST_ON_CHANGE_ORDER'
);
